<template>
	<slot :items="total" />
</template>

<script setup>
	const total = computed(() => useWebshop().getCartData()?.total);
</script>
